import React from "react";

export default function BlankPane({
    blankCount,
    onBlankCountChange,
    activeLines = [],
    orderLineId,
    onOrderLineChange,
}) {
    return (
        <div className="space-y-3" data-testid="lt-blank-pane">
            <p className="text-sm text-gray-600">
                Issues blank Load Tags with real PLL numbers reserved per
                pallet. Product, Customer, PO, Date, and Order # all print;
                only the Unit Count is left blank — operators capture qty
                later during RP, then reprint the tag.
            </p>
            <div>
                <label className="block text-xs font-semibold uppercase tracking-wider text-gray-600 mb-1">
                    Product (order line)
                </label>
                <select
                    value={orderLineId || ""}
                    onChange={(e) => onOrderLineChange?.(e.target.value)}
                    className="odr-input w-full rounded-sm border border-gray-300 px-3 text-sm"
                    data-testid="lt-blank-order-line"
                >
                    <option value="">Select a line...</option>
                    {activeLines.map((ln) => (
                        <option key={ln.id} value={ln.id}>
                            #{ln.line_no} —{" "}
                            {ln.product_snapshot?.name || ln.product_name || "Product"}
                            {ln.qty_ordered ? ` · ${ln.qty_ordered.toLocaleString()} ordered` : ""}
                        </option>
                    ))}
                </select>
            </div>
            <div>
                <label className="block text-xs font-semibold uppercase tracking-wider text-gray-600 mb-1">
                    Number of blank pallets
                </label>
                <input
                    type="number"
                    min="1"
                    max="50"
                    value={blankCount}
                    onChange={(e) => onBlankCountChange(Number(e.target.value) || 1)}
                    className="odr-input w-32 rounded-sm border border-gray-300 px-3 text-sm odr-mono"
                    data-testid="lt-blank-count"
                />
            </div>
        </div>
    );
}
